/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteRouteImport } from './routes/$lang/route'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangAdminRouteRouteImport } from './routes/$lang/admin/route'
import { Route as LangAppRouteRouteImport } from './routes/$lang/app/route'
import { Route as LangClaimRouteImport } from './routes/$lang/claim'
import { Route as LangDesignRouteImport } from './routes/$lang/design'
import { Route as LangForFacilitatorsRouteImport } from './routes/$lang/for-facilitators'
import { Route as LangForgotPasswordRouteImport } from './routes/$lang/forgot-password'
import { Route as LangLoginRouteImport } from './routes/$lang/login'
import { Route as LangPricingRouteImport } from './routes/$lang/pricing'
import { Route as LangResetPasswordRouteImport } from './routes/$lang/reset-password'
import { Route as LangSignupRouteImport } from './routes/$lang/signup'
import { Route as LangStudioRouteRouteImport } from './routes/$lang/studio/route'
import { Route as LangVerifyEmailRouteImport } from './routes/$lang/verify-email'
import { Route as LangAdminIndexRouteImport } from './routes/$lang/admin/index'
import { Route as LangAdminAiRouteImport } from './routes/$lang/admin/ai'
import { Route as LangAdminAuditRouteImport } from './routes/$lang/admin/audit'
import { Route as LangAdminSystemRouteImport } from './routes/$lang/admin/system'
import { Route as LangAppIndexRouteImport } from './routes/$lang/app/index'
import { Route as LangAppBillingRouteImport } from './routes/$lang/app/billing'
import { Route as LangAppProfileRouteImport } from './routes/$lang/app/profile'
import { Route as LangJCodeRouteImport } from './routes/$lang/j.$code'
import { Route as LangLegalImprintRouteImport } from './routes/$lang/legal/imprint'
import { Route as LangLegalPrivacyRouteImport } from './routes/$lang/legal/privacy'
import { Route as LangLegalTermsRouteImport } from './routes/$lang/legal/terms'
import { Route as LangPlaySessionIdRouteImport } from './routes/$lang/play.$sessionId'
import { Route as LangSoloSessionIdRouteImport } from './routes/$lang/solo.$sessionId'
import { Route as LangStudioIndexRouteImport } from './routes/$lang/studio/index'
import { Route as LangStudioBillingRouteImport } from './routes/$lang/studio/billing'
import { Route as LangStudioSettingsRouteImport } from './routes/$lang/studio/settings'
import { Route as LangAdminContentTranslationsRouteImport } from './routes/$lang/admin/content.translations'
import { Route as LangAdminSessionsIndexRouteImport } from './routes/$lang/admin/sessions.index'
import { Route as LangAdminSessionsIdRouteImport } from './routes/$lang/admin/sessions.$id'
import { Route as LangAdminUsersIndexRouteImport } from './routes/$lang/admin/users.index'
import { Route as LangAdminUsersIdRouteImport } from './routes/$lang/admin/users.$id'
import { Route as LangAppSessionsIndexRouteImport } from './routes/$lang/app/sessions.index'
import { Route as LangAppSessionsIdRouteImport } from './routes/$lang/app/sessions.$id'
import { Route as LangStudioResultsIdRouteImport } from './routes/$lang/studio/results.$id'
import { Route as LangStudioSessionsIndexRouteImport } from './routes/$lang/studio/sessions.index'
import { Route as LangStudioSessionsNewRouteImport } from './routes/$lang/studio/sessions.new'
import { Route as LangAdminContentBoardsIndexRouteImport } from './routes/$lang/admin/content.boards.index'
import { Route as LangAdminContentBoardsIdRouteImport } from './routes/$lang/admin/content.boards.$id'
import { Route as LangAdminContentRulesetsIndexRouteImport } from './routes/$lang/admin/content.rulesets.index'
import { Route as LangAdminContentRulesetsIdRouteImport } from './routes/$lang/admin/content.rulesets.$id'
import { Route as LangStudioSessionsIdManageRouteImport } from './routes/$lang/studio/sessions.$id.manage'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRouteRoute = LangRouteRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangAdminRouteRoute = LangAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangAppRouteRoute = LangAppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangClaimRoute = LangClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangDesignRoute = LangDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangForFacilitatorsRoute = LangForFacilitatorsRouteImport.update({
  id: '/for-facilitators',
  path: '/for-facilitators',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangForgotPasswordRoute = LangForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangLoginRoute = LangLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangPricingRoute = LangPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangResetPasswordRoute = LangResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangSignupRoute = LangSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangStudioRouteRoute = LangStudioRouteRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangVerifyEmailRoute = LangVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangAdminIndexRoute = LangAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminAiRoute = LangAdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminAuditRoute = LangAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminSystemRoute = LangAdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAppIndexRoute = LangAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangAppRouteRoute,
} as any)
const LangAppBillingRoute = LangAppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LangAppRouteRoute,
} as any)
const LangAppProfileRoute = LangAppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LangAppRouteRoute,
} as any)
const LangJCodeRoute = LangJCodeRouteImport.update({
  id: '/j/$code',
  path: '/j/$code',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangLegalImprintRoute = LangLegalImprintRouteImport.update({
  id: '/legal/imprint',
  path: '/legal/imprint',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangLegalPrivacyRoute = LangLegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangLegalTermsRoute = LangLegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangPlaySessionIdRoute = LangPlaySessionIdRouteImport.update({
  id: '/play/$sessionId',
  path: '/play/$sessionId',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangSoloSessionIdRoute = LangSoloSessionIdRouteImport.update({
  id: '/solo/$sessionId',
  path: '/solo/$sessionId',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangStudioIndexRoute = LangStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangStudioBillingRoute = LangStudioBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangStudioSettingsRoute = LangStudioSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangAdminContentTranslationsRoute =
  LangAdminContentTranslationsRouteImport.update({
    id: '/content/translations',
    path: '/content/translations',
    getParentRoute: () => LangAdminRouteRoute,
  } as any)
const LangAdminSessionsIndexRoute = LangAdminSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminSessionsIdRoute = LangAdminSessionsIdRouteImport.update({
  id: '/sessions/$id',
  path: '/sessions/$id',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminUsersIndexRoute = LangAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAdminUsersIdRoute = LangAdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => LangAdminRouteRoute,
} as any)
const LangAppSessionsIndexRoute = LangAppSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => LangAppRouteRoute,
} as any)
const LangAppSessionsIdRoute = LangAppSessionsIdRouteImport.update({
  id: '/sessions/$id',
  path: '/sessions/$id',
  getParentRoute: () => LangAppRouteRoute,
} as any)
const LangStudioResultsIdRoute = LangStudioResultsIdRouteImport.update({
  id: '/results/$id',
  path: '/results/$id',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangStudioSessionsIndexRoute = LangStudioSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangStudioSessionsNewRoute = LangStudioSessionsNewRouteImport.update({
  id: '/sessions/new',
  path: '/sessions/new',
  getParentRoute: () => LangStudioRouteRoute,
} as any)
const LangAdminContentBoardsIndexRoute =
  LangAdminContentBoardsIndexRouteImport.update({
    id: '/content/boards/',
    path: '/content/boards/',
    getParentRoute: () => LangAdminRouteRoute,
  } as any)
const LangAdminContentBoardsIdRoute =
  LangAdminContentBoardsIdRouteImport.update({
    id: '/content/boards/$id',
    path: '/content/boards/$id',
    getParentRoute: () => LangAdminRouteRoute,
  } as any)
const LangAdminContentRulesetsIndexRoute =
  LangAdminContentRulesetsIndexRouteImport.update({
    id: '/content/rulesets/',
    path: '/content/rulesets/',
    getParentRoute: () => LangAdminRouteRoute,
  } as any)
const LangAdminContentRulesetsIdRoute =
  LangAdminContentRulesetsIdRouteImport.update({
    id: '/content/rulesets/$id',
    path: '/content/rulesets/$id',
    getParentRoute: () => LangAdminRouteRoute,
  } as any)
const LangStudioSessionsIdManageRoute =
  LangStudioSessionsIdManageRouteImport.update({
    id: '/sessions/$id/manage',
    path: '/sessions/$id/manage',
    getParentRoute: () => LangStudioRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteRouteWithChildren
  '/$lang/admin': typeof LangAdminRouteRouteWithChildren
  '/$lang/app': typeof LangAppRouteRouteWithChildren
  '/$lang/studio': typeof LangStudioRouteRouteWithChildren
  '/$lang/about': typeof LangAboutRoute
  '/$lang/claim': typeof LangClaimRoute
  '/$lang/design': typeof LangDesignRoute
  '/$lang/for-facilitators': typeof LangForFacilitatorsRoute
  '/$lang/forgot-password': typeof LangForgotPasswordRoute
  '/$lang/login': typeof LangLoginRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/reset-password': typeof LangResetPasswordRoute
  '/$lang/signup': typeof LangSignupRoute
  '/$lang/verify-email': typeof LangVerifyEmailRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/admin/ai': typeof LangAdminAiRoute
  '/$lang/admin/audit': typeof LangAdminAuditRoute
  '/$lang/admin/system': typeof LangAdminSystemRoute
  '/$lang/app/billing': typeof LangAppBillingRoute
  '/$lang/app/profile': typeof LangAppProfileRoute
  '/$lang/j/$code': typeof LangJCodeRoute
  '/$lang/legal/imprint': typeof LangLegalImprintRoute
  '/$lang/legal/privacy': typeof LangLegalPrivacyRoute
  '/$lang/legal/terms': typeof LangLegalTermsRoute
  '/$lang/play/$sessionId': typeof LangPlaySessionIdRoute
  '/$lang/solo/$sessionId': typeof LangSoloSessionIdRoute
  '/$lang/studio/billing': typeof LangStudioBillingRoute
  '/$lang/studio/settings': typeof LangStudioSettingsRoute
  '/$lang/admin/': typeof LangAdminIndexRoute
  '/$lang/app/': typeof LangAppIndexRoute
  '/$lang/studio/': typeof LangStudioIndexRoute
  '/$lang/admin/content/translations': typeof LangAdminContentTranslationsRoute
  '/$lang/admin/sessions/$id': typeof LangAdminSessionsIdRoute
  '/$lang/admin/users/$id': typeof LangAdminUsersIdRoute
  '/$lang/app/sessions/$id': typeof LangAppSessionsIdRoute
  '/$lang/studio/results/$id': typeof LangStudioResultsIdRoute
  '/$lang/studio/sessions/new': typeof LangStudioSessionsNewRoute
  '/$lang/admin/sessions/': typeof LangAdminSessionsIndexRoute
  '/$lang/admin/users/': typeof LangAdminUsersIndexRoute
  '/$lang/app/sessions/': typeof LangAppSessionsIndexRoute
  '/$lang/studio/sessions/': typeof LangStudioSessionsIndexRoute
  '/$lang/admin/content/boards/$id': typeof LangAdminContentBoardsIdRoute
  '/$lang/admin/content/rulesets/$id': typeof LangAdminContentRulesetsIdRoute
  '/$lang/studio/sessions/$id/manage': typeof LangStudioSessionsIdManageRoute
  '/$lang/admin/content/boards/': typeof LangAdminContentBoardsIndexRoute
  '/$lang/admin/content/rulesets/': typeof LangAdminContentRulesetsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/claim': typeof LangClaimRoute
  '/$lang/design': typeof LangDesignRoute
  '/$lang/for-facilitators': typeof LangForFacilitatorsRoute
  '/$lang/forgot-password': typeof LangForgotPasswordRoute
  '/$lang/login': typeof LangLoginRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/reset-password': typeof LangResetPasswordRoute
  '/$lang/signup': typeof LangSignupRoute
  '/$lang/verify-email': typeof LangVerifyEmailRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/admin/ai': typeof LangAdminAiRoute
  '/$lang/admin/audit': typeof LangAdminAuditRoute
  '/$lang/admin/system': typeof LangAdminSystemRoute
  '/$lang/app/billing': typeof LangAppBillingRoute
  '/$lang/app/profile': typeof LangAppProfileRoute
  '/$lang/j/$code': typeof LangJCodeRoute
  '/$lang/legal/imprint': typeof LangLegalImprintRoute
  '/$lang/legal/privacy': typeof LangLegalPrivacyRoute
  '/$lang/legal/terms': typeof LangLegalTermsRoute
  '/$lang/play/$sessionId': typeof LangPlaySessionIdRoute
  '/$lang/solo/$sessionId': typeof LangSoloSessionIdRoute
  '/$lang/studio/billing': typeof LangStudioBillingRoute
  '/$lang/studio/settings': typeof LangStudioSettingsRoute
  '/$lang/admin': typeof LangAdminIndexRoute
  '/$lang/app': typeof LangAppIndexRoute
  '/$lang/studio': typeof LangStudioIndexRoute
  '/$lang/admin/content/translations': typeof LangAdminContentTranslationsRoute
  '/$lang/admin/sessions/$id': typeof LangAdminSessionsIdRoute
  '/$lang/admin/users/$id': typeof LangAdminUsersIdRoute
  '/$lang/app/sessions/$id': typeof LangAppSessionsIdRoute
  '/$lang/studio/results/$id': typeof LangStudioResultsIdRoute
  '/$lang/studio/sessions/new': typeof LangStudioSessionsNewRoute
  '/$lang/admin/sessions': typeof LangAdminSessionsIndexRoute
  '/$lang/admin/users': typeof LangAdminUsersIndexRoute
  '/$lang/app/sessions': typeof LangAppSessionsIndexRoute
  '/$lang/studio/sessions': typeof LangStudioSessionsIndexRoute
  '/$lang/admin/content/boards/$id': typeof LangAdminContentBoardsIdRoute
  '/$lang/admin/content/rulesets/$id': typeof LangAdminContentRulesetsIdRoute
  '/$lang/studio/sessions/$id/manage': typeof LangStudioSessionsIdManageRoute
  '/$lang/admin/content/boards': typeof LangAdminContentBoardsIndexRoute
  '/$lang/admin/content/rulesets': typeof LangAdminContentRulesetsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteRouteWithChildren
  '/$lang/admin': typeof LangAdminRouteRouteWithChildren
  '/$lang/app': typeof LangAppRouteRouteWithChildren
  '/$lang/studio': typeof LangStudioRouteRouteWithChildren
  '/$lang/about': typeof LangAboutRoute
  '/$lang/claim': typeof LangClaimRoute
  '/$lang/design': typeof LangDesignRoute
  '/$lang/for-facilitators': typeof LangForFacilitatorsRoute
  '/$lang/forgot-password': typeof LangForgotPasswordRoute
  '/$lang/login': typeof LangLoginRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/reset-password': typeof LangResetPasswordRoute
  '/$lang/signup': typeof LangSignupRoute
  '/$lang/verify-email': typeof LangVerifyEmailRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/admin/ai': typeof LangAdminAiRoute
  '/$lang/admin/audit': typeof LangAdminAuditRoute
  '/$lang/admin/system': typeof LangAdminSystemRoute
  '/$lang/app/billing': typeof LangAppBillingRoute
  '/$lang/app/profile': typeof LangAppProfileRoute
  '/$lang/j/$code': typeof LangJCodeRoute
  '/$lang/legal/imprint': typeof LangLegalImprintRoute
  '/$lang/legal/privacy': typeof LangLegalPrivacyRoute
  '/$lang/legal/terms': typeof LangLegalTermsRoute
  '/$lang/play/$sessionId': typeof LangPlaySessionIdRoute
  '/$lang/solo/$sessionId': typeof LangSoloSessionIdRoute
  '/$lang/studio/billing': typeof LangStudioBillingRoute
  '/$lang/studio/settings': typeof LangStudioSettingsRoute
  '/$lang/admin/': typeof LangAdminIndexRoute
  '/$lang/app/': typeof LangAppIndexRoute
  '/$lang/studio/': typeof LangStudioIndexRoute
  '/$lang/admin/content/translations': typeof LangAdminContentTranslationsRoute
  '/$lang/admin/sessions/$id': typeof LangAdminSessionsIdRoute
  '/$lang/admin/users/$id': typeof LangAdminUsersIdRoute
  '/$lang/app/sessions/$id': typeof LangAppSessionsIdRoute
  '/$lang/studio/results/$id': typeof LangStudioResultsIdRoute
  '/$lang/studio/sessions/new': typeof LangStudioSessionsNewRoute
  '/$lang/admin/sessions/': typeof LangAdminSessionsIndexRoute
  '/$lang/admin/users/': typeof LangAdminUsersIndexRoute
  '/$lang/app/sessions/': typeof LangAppSessionsIndexRoute
  '/$lang/studio/sessions/': typeof LangStudioSessionsIndexRoute
  '/$lang/admin/content/boards/$id': typeof LangAdminContentBoardsIdRoute
  '/$lang/admin/content/rulesets/$id': typeof LangAdminContentRulesetsIdRoute
  '/$lang/studio/sessions/$id/manage': typeof LangStudioSessionsIdManageRoute
  '/$lang/admin/content/boards/': typeof LangAdminContentBoardsIndexRoute
  '/$lang/admin/content/rulesets/': typeof LangAdminContentRulesetsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/$lang/admin'
    | '/$lang/app'
    | '/$lang/studio'
    | '/$lang/about'
    | '/$lang/claim'
    | '/$lang/design'
    | '/$lang/for-facilitators'
    | '/$lang/forgot-password'
    | '/$lang/login'
    | '/$lang/pricing'
    | '/$lang/reset-password'
    | '/$lang/signup'
    | '/$lang/verify-email'
    | '/$lang/'
    | '/$lang/admin/ai'
    | '/$lang/admin/audit'
    | '/$lang/admin/system'
    | '/$lang/app/billing'
    | '/$lang/app/profile'
    | '/$lang/j/$code'
    | '/$lang/legal/imprint'
    | '/$lang/legal/privacy'
    | '/$lang/legal/terms'
    | '/$lang/play/$sessionId'
    | '/$lang/solo/$sessionId'
    | '/$lang/studio/billing'
    | '/$lang/studio/settings'
    | '/$lang/admin/'
    | '/$lang/app/'
    | '/$lang/studio/'
    | '/$lang/admin/content/translations'
    | '/$lang/admin/sessions/$id'
    | '/$lang/admin/users/$id'
    | '/$lang/app/sessions/$id'
    | '/$lang/studio/results/$id'
    | '/$lang/studio/sessions/new'
    | '/$lang/admin/sessions/'
    | '/$lang/admin/users/'
    | '/$lang/app/sessions/'
    | '/$lang/studio/sessions/'
    | '/$lang/admin/content/boards/$id'
    | '/$lang/admin/content/rulesets/$id'
    | '/$lang/studio/sessions/$id/manage'
    | '/$lang/admin/content/boards/'
    | '/$lang/admin/content/rulesets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang/about'
    | '/$lang/claim'
    | '/$lang/design'
    | '/$lang/for-facilitators'
    | '/$lang/forgot-password'
    | '/$lang/login'
    | '/$lang/pricing'
    | '/$lang/reset-password'
    | '/$lang/signup'
    | '/$lang/verify-email'
    | '/$lang'
    | '/$lang/admin/ai'
    | '/$lang/admin/audit'
    | '/$lang/admin/system'
    | '/$lang/app/billing'
    | '/$lang/app/profile'
    | '/$lang/j/$code'
    | '/$lang/legal/imprint'
    | '/$lang/legal/privacy'
    | '/$lang/legal/terms'
    | '/$lang/play/$sessionId'
    | '/$lang/solo/$sessionId'
    | '/$lang/studio/billing'
    | '/$lang/studio/settings'
    | '/$lang/admin'
    | '/$lang/app'
    | '/$lang/studio'
    | '/$lang/admin/content/translations'
    | '/$lang/admin/sessions/$id'
    | '/$lang/admin/users/$id'
    | '/$lang/app/sessions/$id'
    | '/$lang/studio/results/$id'
    | '/$lang/studio/sessions/new'
    | '/$lang/admin/sessions'
    | '/$lang/admin/users'
    | '/$lang/app/sessions'
    | '/$lang/studio/sessions'
    | '/$lang/admin/content/boards/$id'
    | '/$lang/admin/content/rulesets/$id'
    | '/$lang/studio/sessions/$id/manage'
    | '/$lang/admin/content/boards'
    | '/$lang/admin/content/rulesets'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/$lang/admin'
    | '/$lang/app'
    | '/$lang/studio'
    | '/$lang/about'
    | '/$lang/claim'
    | '/$lang/design'
    | '/$lang/for-facilitators'
    | '/$lang/forgot-password'
    | '/$lang/login'
    | '/$lang/pricing'
    | '/$lang/reset-password'
    | '/$lang/signup'
    | '/$lang/verify-email'
    | '/$lang/'
    | '/$lang/admin/ai'
    | '/$lang/admin/audit'
    | '/$lang/admin/system'
    | '/$lang/app/billing'
    | '/$lang/app/profile'
    | '/$lang/j/$code'
    | '/$lang/legal/imprint'
    | '/$lang/legal/privacy'
    | '/$lang/legal/terms'
    | '/$lang/play/$sessionId'
    | '/$lang/solo/$sessionId'
    | '/$lang/studio/billing'
    | '/$lang/studio/settings'
    | '/$lang/admin/'
    | '/$lang/app/'
    | '/$lang/studio/'
    | '/$lang/admin/content/translations'
    | '/$lang/admin/sessions/$id'
    | '/$lang/admin/users/$id'
    | '/$lang/app/sessions/$id'
    | '/$lang/studio/results/$id'
    | '/$lang/studio/sessions/new'
    | '/$lang/admin/sessions/'
    | '/$lang/admin/users/'
    | '/$lang/app/sessions/'
    | '/$lang/studio/sessions/'
    | '/$lang/admin/content/boards/$id'
    | '/$lang/admin/content/rulesets/$id'
    | '/$lang/studio/sessions/$id/manage'
    | '/$lang/admin/content/boards/'
    | '/$lang/admin/content/rulesets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRouteRoute: typeof LangRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/about': {
      id: '/$lang/about'
      path: '/about'
      fullPath: '/$lang/about'
      preLoaderRoute: typeof LangAboutRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/admin': {
      id: '/$lang/admin'
      path: '/admin'
      fullPath: '/$lang/admin'
      preLoaderRoute: typeof LangAdminRouteRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/app': {
      id: '/$lang/app'
      path: '/app'
      fullPath: '/$lang/app'
      preLoaderRoute: typeof LangAppRouteRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/claim': {
      id: '/$lang/claim'
      path: '/claim'
      fullPath: '/$lang/claim'
      preLoaderRoute: typeof LangClaimRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/design': {
      id: '/$lang/design'
      path: '/design'
      fullPath: '/$lang/design'
      preLoaderRoute: typeof LangDesignRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/for-facilitators': {
      id: '/$lang/for-facilitators'
      path: '/for-facilitators'
      fullPath: '/$lang/for-facilitators'
      preLoaderRoute: typeof LangForFacilitatorsRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/forgot-password': {
      id: '/$lang/forgot-password'
      path: '/forgot-password'
      fullPath: '/$lang/forgot-password'
      preLoaderRoute: typeof LangForgotPasswordRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/login': {
      id: '/$lang/login'
      path: '/login'
      fullPath: '/$lang/login'
      preLoaderRoute: typeof LangLoginRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/pricing': {
      id: '/$lang/pricing'
      path: '/pricing'
      fullPath: '/$lang/pricing'
      preLoaderRoute: typeof LangPricingRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/reset-password': {
      id: '/$lang/reset-password'
      path: '/reset-password'
      fullPath: '/$lang/reset-password'
      preLoaderRoute: typeof LangResetPasswordRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/signup': {
      id: '/$lang/signup'
      path: '/signup'
      fullPath: '/$lang/signup'
      preLoaderRoute: typeof LangSignupRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/studio': {
      id: '/$lang/studio'
      path: '/studio'
      fullPath: '/$lang/studio'
      preLoaderRoute: typeof LangStudioRouteRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/verify-email': {
      id: '/$lang/verify-email'
      path: '/verify-email'
      fullPath: '/$lang/verify-email'
      preLoaderRoute: typeof LangVerifyEmailRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/admin/': {
      id: '/$lang/admin/'
      path: '/'
      fullPath: '/$lang/admin/'
      preLoaderRoute: typeof LangAdminIndexRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/ai': {
      id: '/$lang/admin/ai'
      path: '/ai'
      fullPath: '/$lang/admin/ai'
      preLoaderRoute: typeof LangAdminAiRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/audit': {
      id: '/$lang/admin/audit'
      path: '/audit'
      fullPath: '/$lang/admin/audit'
      preLoaderRoute: typeof LangAdminAuditRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/system': {
      id: '/$lang/admin/system'
      path: '/system'
      fullPath: '/$lang/admin/system'
      preLoaderRoute: typeof LangAdminSystemRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/app/': {
      id: '/$lang/app/'
      path: '/'
      fullPath: '/$lang/app/'
      preLoaderRoute: typeof LangAppIndexRouteImport
      parentRoute: typeof LangAppRouteRoute
    }
    '/$lang/app/billing': {
      id: '/$lang/app/billing'
      path: '/billing'
      fullPath: '/$lang/app/billing'
      preLoaderRoute: typeof LangAppBillingRouteImport
      parentRoute: typeof LangAppRouteRoute
    }
    '/$lang/app/profile': {
      id: '/$lang/app/profile'
      path: '/profile'
      fullPath: '/$lang/app/profile'
      preLoaderRoute: typeof LangAppProfileRouteImport
      parentRoute: typeof LangAppRouteRoute
    }
    '/$lang/j/$code': {
      id: '/$lang/j/$code'
      path: '/j/$code'
      fullPath: '/$lang/j/$code'
      preLoaderRoute: typeof LangJCodeRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/legal/imprint': {
      id: '/$lang/legal/imprint'
      path: '/legal/imprint'
      fullPath: '/$lang/legal/imprint'
      preLoaderRoute: typeof LangLegalImprintRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/legal/privacy': {
      id: '/$lang/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/$lang/legal/privacy'
      preLoaderRoute: typeof LangLegalPrivacyRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/legal/terms': {
      id: '/$lang/legal/terms'
      path: '/legal/terms'
      fullPath: '/$lang/legal/terms'
      preLoaderRoute: typeof LangLegalTermsRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/play/$sessionId': {
      id: '/$lang/play/$sessionId'
      path: '/play/$sessionId'
      fullPath: '/$lang/play/$sessionId'
      preLoaderRoute: typeof LangPlaySessionIdRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/solo/$sessionId': {
      id: '/$lang/solo/$sessionId'
      path: '/solo/$sessionId'
      fullPath: '/$lang/solo/$sessionId'
      preLoaderRoute: typeof LangSoloSessionIdRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/studio/': {
      id: '/$lang/studio/'
      path: '/'
      fullPath: '/$lang/studio/'
      preLoaderRoute: typeof LangStudioIndexRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/studio/billing': {
      id: '/$lang/studio/billing'
      path: '/billing'
      fullPath: '/$lang/studio/billing'
      preLoaderRoute: typeof LangStudioBillingRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/studio/settings': {
      id: '/$lang/studio/settings'
      path: '/settings'
      fullPath: '/$lang/studio/settings'
      preLoaderRoute: typeof LangStudioSettingsRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/admin/content/translations': {
      id: '/$lang/admin/content/translations'
      path: '/content/translations'
      fullPath: '/$lang/admin/content/translations'
      preLoaderRoute: typeof LangAdminContentTranslationsRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/sessions/': {
      id: '/$lang/admin/sessions/'
      path: '/sessions'
      fullPath: '/$lang/admin/sessions/'
      preLoaderRoute: typeof LangAdminSessionsIndexRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/sessions/$id': {
      id: '/$lang/admin/sessions/$id'
      path: '/sessions/$id'
      fullPath: '/$lang/admin/sessions/$id'
      preLoaderRoute: typeof LangAdminSessionsIdRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/users/': {
      id: '/$lang/admin/users/'
      path: '/users'
      fullPath: '/$lang/admin/users/'
      preLoaderRoute: typeof LangAdminUsersIndexRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/users/$id': {
      id: '/$lang/admin/users/$id'
      path: '/users/$id'
      fullPath: '/$lang/admin/users/$id'
      preLoaderRoute: typeof LangAdminUsersIdRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/app/sessions/': {
      id: '/$lang/app/sessions/'
      path: '/sessions'
      fullPath: '/$lang/app/sessions/'
      preLoaderRoute: typeof LangAppSessionsIndexRouteImport
      parentRoute: typeof LangAppRouteRoute
    }
    '/$lang/app/sessions/$id': {
      id: '/$lang/app/sessions/$id'
      path: '/sessions/$id'
      fullPath: '/$lang/app/sessions/$id'
      preLoaderRoute: typeof LangAppSessionsIdRouteImport
      parentRoute: typeof LangAppRouteRoute
    }
    '/$lang/studio/results/$id': {
      id: '/$lang/studio/results/$id'
      path: '/results/$id'
      fullPath: '/$lang/studio/results/$id'
      preLoaderRoute: typeof LangStudioResultsIdRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/studio/sessions/': {
      id: '/$lang/studio/sessions/'
      path: '/sessions'
      fullPath: '/$lang/studio/sessions/'
      preLoaderRoute: typeof LangStudioSessionsIndexRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/studio/sessions/new': {
      id: '/$lang/studio/sessions/new'
      path: '/sessions/new'
      fullPath: '/$lang/studio/sessions/new'
      preLoaderRoute: typeof LangStudioSessionsNewRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
    '/$lang/admin/content/boards/': {
      id: '/$lang/admin/content/boards/'
      path: '/content/boards'
      fullPath: '/$lang/admin/content/boards/'
      preLoaderRoute: typeof LangAdminContentBoardsIndexRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/content/boards/$id': {
      id: '/$lang/admin/content/boards/$id'
      path: '/content/boards/$id'
      fullPath: '/$lang/admin/content/boards/$id'
      preLoaderRoute: typeof LangAdminContentBoardsIdRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/content/rulesets/': {
      id: '/$lang/admin/content/rulesets/'
      path: '/content/rulesets'
      fullPath: '/$lang/admin/content/rulesets/'
      preLoaderRoute: typeof LangAdminContentRulesetsIndexRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/admin/content/rulesets/$id': {
      id: '/$lang/admin/content/rulesets/$id'
      path: '/content/rulesets/$id'
      fullPath: '/$lang/admin/content/rulesets/$id'
      preLoaderRoute: typeof LangAdminContentRulesetsIdRouteImport
      parentRoute: typeof LangAdminRouteRoute
    }
    '/$lang/studio/sessions/$id/manage': {
      id: '/$lang/studio/sessions/$id/manage'
      path: '/sessions/$id/manage'
      fullPath: '/$lang/studio/sessions/$id/manage'
      preLoaderRoute: typeof LangStudioSessionsIdManageRouteImport
      parentRoute: typeof LangStudioRouteRoute
    }
  }
}

interface LangAdminRouteRouteChildren {
  LangAdminAiRoute: typeof LangAdminAiRoute
  LangAdminAuditRoute: typeof LangAdminAuditRoute
  LangAdminSystemRoute: typeof LangAdminSystemRoute
  LangAdminIndexRoute: typeof LangAdminIndexRoute
  LangAdminContentTranslationsRoute: typeof LangAdminContentTranslationsRoute
  LangAdminSessionsIdRoute: typeof LangAdminSessionsIdRoute
  LangAdminUsersIdRoute: typeof LangAdminUsersIdRoute
  LangAdminSessionsIndexRoute: typeof LangAdminSessionsIndexRoute
  LangAdminUsersIndexRoute: typeof LangAdminUsersIndexRoute
  LangAdminContentBoardsIdRoute: typeof LangAdminContentBoardsIdRoute
  LangAdminContentRulesetsIdRoute: typeof LangAdminContentRulesetsIdRoute
  LangAdminContentBoardsIndexRoute: typeof LangAdminContentBoardsIndexRoute
  LangAdminContentRulesetsIndexRoute: typeof LangAdminContentRulesetsIndexRoute
}

const LangAdminRouteRouteChildren: LangAdminRouteRouteChildren = {
  LangAdminAiRoute: LangAdminAiRoute,
  LangAdminAuditRoute: LangAdminAuditRoute,
  LangAdminSystemRoute: LangAdminSystemRoute,
  LangAdminIndexRoute: LangAdminIndexRoute,
  LangAdminContentTranslationsRoute: LangAdminContentTranslationsRoute,
  LangAdminSessionsIdRoute: LangAdminSessionsIdRoute,
  LangAdminUsersIdRoute: LangAdminUsersIdRoute,
  LangAdminSessionsIndexRoute: LangAdminSessionsIndexRoute,
  LangAdminUsersIndexRoute: LangAdminUsersIndexRoute,
  LangAdminContentBoardsIdRoute: LangAdminContentBoardsIdRoute,
  LangAdminContentRulesetsIdRoute: LangAdminContentRulesetsIdRoute,
  LangAdminContentBoardsIndexRoute: LangAdminContentBoardsIndexRoute,
  LangAdminContentRulesetsIndexRoute: LangAdminContentRulesetsIndexRoute,
}

const LangAdminRouteRouteWithChildren = LangAdminRouteRoute._addFileChildren(
  LangAdminRouteRouteChildren,
)

interface LangAppRouteRouteChildren {
  LangAppBillingRoute: typeof LangAppBillingRoute
  LangAppProfileRoute: typeof LangAppProfileRoute
  LangAppIndexRoute: typeof LangAppIndexRoute
  LangAppSessionsIdRoute: typeof LangAppSessionsIdRoute
  LangAppSessionsIndexRoute: typeof LangAppSessionsIndexRoute
}

const LangAppRouteRouteChildren: LangAppRouteRouteChildren = {
  LangAppBillingRoute: LangAppBillingRoute,
  LangAppProfileRoute: LangAppProfileRoute,
  LangAppIndexRoute: LangAppIndexRoute,
  LangAppSessionsIdRoute: LangAppSessionsIdRoute,
  LangAppSessionsIndexRoute: LangAppSessionsIndexRoute,
}

const LangAppRouteRouteWithChildren = LangAppRouteRoute._addFileChildren(
  LangAppRouteRouteChildren,
)

interface LangStudioRouteRouteChildren {
  LangStudioBillingRoute: typeof LangStudioBillingRoute
  LangStudioSettingsRoute: typeof LangStudioSettingsRoute
  LangStudioIndexRoute: typeof LangStudioIndexRoute
  LangStudioResultsIdRoute: typeof LangStudioResultsIdRoute
  LangStudioSessionsNewRoute: typeof LangStudioSessionsNewRoute
  LangStudioSessionsIndexRoute: typeof LangStudioSessionsIndexRoute
  LangStudioSessionsIdManageRoute: typeof LangStudioSessionsIdManageRoute
}

const LangStudioRouteRouteChildren: LangStudioRouteRouteChildren = {
  LangStudioBillingRoute: LangStudioBillingRoute,
  LangStudioSettingsRoute: LangStudioSettingsRoute,
  LangStudioIndexRoute: LangStudioIndexRoute,
  LangStudioResultsIdRoute: LangStudioResultsIdRoute,
  LangStudioSessionsNewRoute: LangStudioSessionsNewRoute,
  LangStudioSessionsIndexRoute: LangStudioSessionsIndexRoute,
  LangStudioSessionsIdManageRoute: LangStudioSessionsIdManageRoute,
}

const LangStudioRouteRouteWithChildren = LangStudioRouteRoute._addFileChildren(
  LangStudioRouteRouteChildren,
)

interface LangRouteRouteChildren {
  LangAdminRouteRoute: typeof LangAdminRouteRouteWithChildren
  LangAppRouteRoute: typeof LangAppRouteRouteWithChildren
  LangStudioRouteRoute: typeof LangStudioRouteRouteWithChildren
  LangAboutRoute: typeof LangAboutRoute
  LangClaimRoute: typeof LangClaimRoute
  LangDesignRoute: typeof LangDesignRoute
  LangForFacilitatorsRoute: typeof LangForFacilitatorsRoute
  LangForgotPasswordRoute: typeof LangForgotPasswordRoute
  LangLoginRoute: typeof LangLoginRoute
  LangPricingRoute: typeof LangPricingRoute
  LangResetPasswordRoute: typeof LangResetPasswordRoute
  LangSignupRoute: typeof LangSignupRoute
  LangVerifyEmailRoute: typeof LangVerifyEmailRoute
  LangIndexRoute: typeof LangIndexRoute
  LangJCodeRoute: typeof LangJCodeRoute
  LangLegalImprintRoute: typeof LangLegalImprintRoute
  LangLegalPrivacyRoute: typeof LangLegalPrivacyRoute
  LangLegalTermsRoute: typeof LangLegalTermsRoute
  LangPlaySessionIdRoute: typeof LangPlaySessionIdRoute
  LangSoloSessionIdRoute: typeof LangSoloSessionIdRoute
}

const LangRouteRouteChildren: LangRouteRouteChildren = {
  LangAdminRouteRoute: LangAdminRouteRouteWithChildren,
  LangAppRouteRoute: LangAppRouteRouteWithChildren,
  LangStudioRouteRoute: LangStudioRouteRouteWithChildren,
  LangAboutRoute: LangAboutRoute,
  LangClaimRoute: LangClaimRoute,
  LangDesignRoute: LangDesignRoute,
  LangForFacilitatorsRoute: LangForFacilitatorsRoute,
  LangForgotPasswordRoute: LangForgotPasswordRoute,
  LangLoginRoute: LangLoginRoute,
  LangPricingRoute: LangPricingRoute,
  LangResetPasswordRoute: LangResetPasswordRoute,
  LangSignupRoute: LangSignupRoute,
  LangVerifyEmailRoute: LangVerifyEmailRoute,
  LangIndexRoute: LangIndexRoute,
  LangJCodeRoute: LangJCodeRoute,
  LangLegalImprintRoute: LangLegalImprintRoute,
  LangLegalPrivacyRoute: LangLegalPrivacyRoute,
  LangLegalTermsRoute: LangLegalTermsRoute,
  LangPlaySessionIdRoute: LangPlaySessionIdRoute,
  LangSoloSessionIdRoute: LangSoloSessionIdRoute,
}

const LangRouteRouteWithChildren = LangRouteRoute._addFileChildren(
  LangRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRouteRoute: LangRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
